import CONST from './order.constants';
import STATES from '../../states';

export default class OrderNumberService {
    [x: string]: any;
 	 static $inject = ['$state','$stateParams','$filter','MsisdnsService', '$translate', 'AccountService', 'ModalService', '$window', 'Router'];
    constructor($state, $stateParams, $filter, MsisdnsService, $translate, AccountService, ModalService, $window, Router) {
        this.$state = $state;
        this.msisdnsService = MsisdnsService;
        this.$stateParams = $stateParams;
        this.isoToCountry = $filter('isoToCountry');
        this.$translate = $translate;
        this.isFullyConfigured = true;
        this.accountService = AccountService;
        this.accountService.getAccountConfig().subscribe(conf => {
          this.isFullyConfigured = conf.data;
        });
        this.ModalService = ModalService;
        this.$window = $window;
        this.router = Router;
    }

    getMessage(type) {
        return CONST.MESSAGES[type];
    }

    getMessageValues(pricing) {
        return {
            type: this.generateLabel(pricing.type, pricing.countryCode),
            cost: pricing.price,
            deliveryTime: pricing.deliveryTime
        }
    }

    generateLabel(recommendType, countryCode) {
        let type = recommendType === CONST.GENERATE_VARIABLES.LOCAL ? CONST.GENERATE_VARIABLES.OFFICE : recommendType.toLowerCase();
        return `${ this.isoToCountry(countryCode) } ${ type }`;
    }

    getType(number) {
        if (!number.availableToBuyWithoutSupport) {
          return CONST.TYPE.ORDER;
        }
        return number.availableInstantly ? CONST.TYPE.BUY : CONST.TYPE.ORDER;
    }

    hasDocuments(number) {
        return number.requiredDocumentsCodes && number.requiredDocumentsCodes.length;
    }

    nextStep(number, params) {
        if (this.getType(number) === CONST.TYPE.ORDER || this.getType(number) === CONST.TYPE.BUY) {
            this.$state.go(STATES.BUY_NUMBER, params);
        } else if (this.getType(number) === CONST.TYPE.GET_FREE || this.getType(number) === CONST.TYPE.ORDER_FREE) {
            this.$state.go(STATES.GET_NUMBER, params);
        }
    }

    onPlanRequired() {
      this.$state.go(STATES.MY_ACCOUNT)
    }

    backStep() {
        this.$window.history.back();
    }

    limitsExceeded() {
      return this.Msisdns.limitsExceeded().$promise
    }

    onGetNumber(pricing, selectedMsisdnId: number | string, selectedNumber: string, label: string) {
        const params = {
          label,
          pricingId: pricing.id,
          actionType: typeof selectedMsisdnId === 'string' ? CONST.TYPE.ORDER : CONST.TYPE.BUY,
          selectedMsisdnId,
          selectedMsisdnDisplayedValue: selectedNumber,
        };

        return this.msisdnsService.buyNumber({}, params, () => {
          if (this.isFullyConfigured) {
            this.$state.go(STATES.NUMBERS, {isNew: true, selectedNumber})
          } else {
            this.$state.go(STATES.WIDGET_EXTENSION);
          }
        }, error => {
          this.handleGetNewNumberResponseError(error);
        }).$promise
    }

    onGetInitialNumber(pricing, selectedMsisdnId: number | string, selectedNumber: string, label: string) {
      const params = {
        label,
        pricingId: pricing.id,
        actionType: CONST.TYPE.GET_INITIAL,
        selectedMsisdnId,
        selectedMsisdnDisplayedValue: selectedNumber,
      };

      return this.msisdnsService.assignInitialNumber({}, params, () => {
        this.accountService.changeAccountConfig({ data: true });
        this.$state.go(STATES.WIDGET_EXTENSION)
      }, error => {
        this.handleGetNewNumberResponseError(error);
      }).$promise
    }

    handleGetNewNumberResponseError(error) {
      const numberNotAvailable = error && error.data && error.data.length && error.data[0] === 'DIDWW_NUMBER_NOT_AVAILABLE';
      if (numberNotAvailable) {
        this.ModalService.showChannelsWarningModal(CONST.MESSAGES.NUMBER_NOT_AVAILABLE, true);
      }
    }

    getPrice(price) {
        return price;
    }

}
